export const initialMOTState = {
    vehicleStatus: {},
};
export const MOTActionTypes = {
    VEHICLE_STATUS: '@@platform/mot/VEHICLE_STATUS',
    VEHICLE_STATUS_FAILURE: '@@platform/mot/VEHICLE_STATUS_FAILURE',
    VEHICLE_STATUS_SUCCESS: '@@platform/mot/VEHICLE_STATUS_SUCCESS',
};
